import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isTokenValid } from '../../core/auth/jwt-claims';

/**
 * Blocks the authenticated areas (/dashboard, /super-admin) when there is no token or it
 * has expired, and sends the user to /login with a returnUrl. Use for both canActivate and
 * canActivateChild so navigation inside the area re-checks expiry.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  if (isTokenValid()) return true;

  sessionStorage.clear();
  return inject(Router).createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
